const resource = 'users'

export default $axios => ({
  fetch(params) {
    return $axios.$get(`/${resource}`, params)
  },
  get(id, params) {
    return $axios.$get(`/${resource}/${id}`, params)
  },
  update(id, params) {
    return $axios.$put(`/${resource}/${id}`, params)
  },
  create(params) {
    return $axios.$post(`/${resource}`, params)
  },
  fetchAdresses(id, params) {
    return $axios.$get(`/${resource}/${id}/user_addresses`, params)
  },
  forgotPassword(params) {
    return $axios.$post(`/${resource}/forgot_password`, params)
  },
  newPassword(params) {
    return $axios.$patch(`/${resource}/new_password`, params)
  },
  sendVerificationEmail(params) {
    return $axios.$post(`/${resource}/resend_verification_email`, params)
  },
  verifyEmail(params) {
    return $axios.$patch(`/${resource}/verify_email`, params)
  },
  getAmazonConnectButton(callbackUrl) {
    return $axios.$get(
      `/auth/social/amazon/redirect?redirect_url=${callbackUrl}`
    )
  },
  fetchAccountMe() {
    return $axios.$get('/v2/account/me')
  },
  fetchLastRelayPoint(shippingMethod) {
    return $axios.$get('/v2/account/last-relay-point', {
      params: { shipping_method: shippingMethod },
    })
  },

  getServiceName: name => 'userService',
})
